import { forwardRef, type SVGProps } from 'react';

export type ThumbDownIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const ThumbDownIcon = forwardRef<SVGSVGElement, ThumbDownIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <g clipPath="url(#a)">
      <path
        d="M4.66667 8.66666V3.33333C4.66667 3.15652 4.59643 2.98695 4.4714 2.86192C4.34638 2.7369 4.17681 2.66666 4 2.66666H2.66667C2.48986 2.66666 2.32029 2.7369 2.19526 2.86192C2.07024 2.98695 2 3.15652 2 3.33333V8C2 8.17681 2.07024 8.34638 2.19526 8.4714C2.32029 8.59642 2.48986 8.66666 2.66667 8.66666H4.66667ZM4.66667 8.66666C5.37391 8.66666 6.05219 8.94761 6.55228 9.44771C7.05238 9.94781 7.33333 10.6261 7.33333 11.3333V12C7.33333 12.3536 7.47381 12.6928 7.72386 12.9428C7.97391 13.1929 8.31304 13.3333 8.66667 13.3333C9.02029 13.3333 9.35943 13.1929 9.60948 12.9428C9.85952 12.6928 10 12.3536 10 12V8.66666H12C12.3536 8.66666 12.6928 8.52619 12.9428 8.27614C13.1929 8.02609 13.3333 7.68695 13.3333 7.33333L12.6667 4C12.5708 3.59101 12.3889 3.23983 12.1484 2.99935C11.908 2.75887 11.6219 2.64211 11.3333 2.66666H6.66667C6.13623 2.66666 5.62753 2.87738 5.25245 3.25245C4.87738 3.62752 4.66667 4.13623 4.66667 4.66666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect fill="currentColor" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
));

ThumbDownIcon.displayName = 'ThumbDownIcon';
